import api from "@/config/api";
import { useAdmin } from "@/context/admin";
import { Campaign } from "@/types/entities";
import { log } from "@/utils/logger";
import { useQuery } from "@tanstack/react-query";

const useQueryCampaigns = () => {
    const authenticated = useAdmin(state => state.authenticated);
    const enabled = authenticated;

    const getCampaigns = async () => {
        try {
            const data = await api.get<Array<Campaign>>(`/campaigns`);
            return data;
        } catch (e) {
            log.error(e);
        }
    };

    return useQuery({ queryKey: ["campaigns"], queryFn: getCampaigns, enabled });
};

export default useQueryCampaigns;
